<template>

  <div class="img_center">
    <section :id="'splide-' + product.id" class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          <li class="splide__slide">
            <img :src="this.product.bild_url" alt="Product Image" />

          </li>
          <li v-for="(imageUrl, index) in getImageUrls()" :key="index" class="splide__slide">
            <img :src="imageUrl" alt="Product Image" />
          </li>
        </ul>
      </div>
    </section>

    <section :id="'thumbnail-splide-' + product.id" class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          <li class="splide__slide">
            <img :src="this.product.bild_url" alt="Product Image" />

          </li>
          <li v-for="(imageUrl, index) in getImageUrls()" :key="index" class="splide__slide">
            <img :src="imageUrl" alt="Product Image" />
          </li>
        </ul>
      </div>
    </section>
  </div>


</template>

<script>

export default {
  props: ['product'],

  methods: {
    getImageUrls() {
      return this.product.picVariants.split(';');
    }
  }
  ,

  mounted() {
    const mainSplideId = 'splide-' + this.product.id;
    const mainSplideElement = document.getElementById(mainSplideId);

    const thumbnailSplideId = 'thumbnail-splide-' + this.product.id;
    const thumbnailSplideElement = document.getElementById(thumbnailSplideId);

    const mainSplide = new Splide(mainSplideElement, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails = new Splide(thumbnailSplideElement, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    mainSplide.sync(thumbnails);
    mainSplide.mount();
    thumbnails.mount();
  }
};
</script>

<style></style>